import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type SleepNodeOptions = {} & SimpleManaNodeOptions

export default class SleepNode extends SimpleManaNode {

	static nodeName = "Sleep node"
	static nodeDesc = "Do nothing for a few seconds"
	static nodeIcon = '💤'
	static category = NodeCategories.Logistics
	static nodeType = 'SleepNode'


	constructor(options: SleepNodeOptions) {
		super({
			...options,

			cooldown: 0,
		})
	}

	getSymbol() {
		return SleepNode.nodeIcon
	}

	async act(particle: ManaParticle) {

		const delay = 250 * this.getSizeAmp()

		await new Promise((resolve, reject) => {
			setTimeout(resolve, delay)
		})

		return true
	}
}